module.exports = __webpack_public_path__ + "img/sl-pic.dccbc5a3.png";